import Loader from './Loader';

/**
 * Loads data via AJAX
 *
 * Expects a URL from data() in order to make the AJAX call.
 */
export default class AjaxLoader extends Loader {
    compile(template, data) {
        Handlebars.registerHelper('select', function(value, options) {

            var select = document.createElement('select');
            select.innerHTML = options.fn(this);

            [].forEach.call(select.options, function(option) {
                if (option.value == value || $.inArray(parseInt(option.value), value) !== -1) {
                    option.setAttribute('selected', 'selected');
                }
            });

            return select.innerHTML;
        });

        var compiled = Handlebars.compile(template);
        return compiled(data);
    }

    render(containerId, templateId, data) {
        var template = $(templateId).html();
        $(containerId).html(this.compile(template, data));
    }

    load(containerId, templateId, data, process) {
        var dataUrl = data.url;
        var dataParams = data.params;
        $(containerId).removeClass('loading').addClass('loading');

        const $this = this;
        return new Promise(function (resolve, reject) {
            $.post(dataUrl, dataParams, function (data) {
                if (typeof data.redirect !== 'undefined') {
                    window.location = data.redirect;
                    return;
                }

                if (typeof process !== 'undefined') {
                    data = process(data);
                }

                $this.render(containerId, templateId, data);
                $(containerId).removeClass('loading').trigger('load.rendered');
                resolve();
            });
        });
    }
}
